import { Box, Checkbox, Menu, TextField, Typography } from "@mui/material";
import { filterMenuStyles } from "../../components/TracksPageComponents/styles";
import { FilterAndSortButton } from "../../components/TracksPageComponents/styles";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useState } from "react";
import { projectFilterMenuStyles, styles } from "./styles";
import { FONT_FAMILY, TEXT_COLOR } from "../../theme";
import { CustomPaper, SelectField, useStyles } from "../MyTracks/styles";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { ProjectsFilterMenuProps } from "./types";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const ProjectsFilterMenu: React.FC<ProjectsFilterMenuProps> = ({
  userNames,
  setSelectedCollaborators,
  setProjects,
  setPage,
  selectedCollaborators,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const classes = useStyles();

  const handleChangeCollaboratorsList = async (
    _event: React.SyntheticEvent<Element, Event>,
    value: unknown
  ) => {
    setPage(0);
    setProjects([]);
    const values = value as Array<string>;
    const tempArr: string[] = [];
    const length = values.length;
    for (let i = 0; i < length; i++) {
      const tag_curr = values[i];
      tempArr.push(tag_curr);
    }
    setSelectedCollaborators(tempArr);
  };

  return (
    <>
      <FilterAndSortButton
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={(e) => setAnchorEl(e.currentTarget as HTMLElement)}
        sx={styles.filterButton}
      >
        <FilterListIcon sx={{ margin: "10px" }} />
        Filters
      </FilterAndSortButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        sx={filterMenuStyles.menu}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <Box sx={projectFilterMenuStyles.menuBox}>
          <Typography sx={{ color: TEXT_COLOR, marginTop: "15px" }}>
            Select Collaborators
          </Typography>
          <SelectField
            multiple
            fullWidth
            id="collaborator-tags"
            options={userNames}
            value={selectedCollaborators ?? []}
            disableCloseOnSelect
            onChange={handleChangeCollaboratorsList}
            renderOption={(props, option, { selected }) => (
              <li {...props} style={{ fontFamily: FONT_FAMILY }}>
                <>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option}
                </>
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label={""}
                InputLabelProps={{ shrink: false }}
                classes={{ root: classes.customTextField }}
              />
            )}
            PaperComponent={CustomPaper}
          />
        </Box>
      </Menu>
    </>
  );
};
